var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ grayscale: _vm.ebo },attrs:{"id":"app"}},[_c('navigation'),_c('router-view'),_c('fter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }